"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupBox = void 0;
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
const three_1 = require("three");
const types_1 = require("~/store/types");
const consts_1 = require("../consts");
const utils_1 = require("../utils");
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("../utils/utils.3d");
const PanelInSlotsUtils_1 = require("./PanelInSlots/PanelInSlotsUtils");
const Viewer_1 = __importDefault(require("../Viewer"));
function isPlasticPanelAndOrthogonalExtrusionPair(a, b) {
    if (!a || !b)
        return false;
    const isTargetPanel = (obj) => { var _a, _b; return utils_1.Utils.isPlasticPanel(obj) && !((_b = (_a = obj).isWireMesh) === null || _b === void 0 ? void 0 : _b.call(_a)); };
    const isTargetExtrusion = (obj) => (0, utils_3d_1.isExtrusion)(obj) && utils_1.Utils.areEqual(obj.scalingAngle, 0);
    return ((isTargetPanel(a) && isTargetExtrusion(b)) ||
        (isTargetPanel(b) && isTargetExtrusion(a)));
}
class GroupBox {
    constructor(uuid, boundingBox, orientedBBox, outerBox, normal, { slots, inboundSnapPts, outboundSnapPts }) {
        this.objectsData = [];
        this.maxObjectsContained = 10;
        this.maxSideSize = 120;
        this.maxVolume = 29000;
        this.boundingBox = boundingBox.clone();
        this.outerBox = this.createGroupOuterBox(this.boundingBox);
        this.objectsData.push({
            objectUUID: uuid,
            objectBox: boundingBox,
            orientedBBox,
            normal,
            intersectsWith: [],
            outerBox,
            slots,
            inboundSnapPts,
            outboundSnapPts,
            temporaryExcluded: false,
        });
    }
    // eslint-disable-next-line class-methods-use-this
    createGroupOuterBox(groupBoundingBox) {
        const geometry = new three_1.BoxGeometry(1, 1, 1);
        const groupOuterBox = new three_1.Mesh(geometry);
        groupBoundingBox.getCenter(groupOuterBox.position);
        groupBoundingBox.getSize(groupOuterBox.scale);
        groupOuterBox.visible = false;
        return groupOuterBox;
    }
    shiftIntersectionsObjectsIndicesFollowingBy(index) {
        for (const objectData of this.objectsData) {
            let offset = 0;
            for (let k = 0; k < objectData.intersectsWith.length - offset; k += 1) {
                if (objectData.intersectsWith[k].groupBoxIndex === index.groupBoxIndex) {
                    if (objectData.intersectsWith[k].objectIndex > index.objectIndex) {
                        const group = objectData.intersectsWith[k].groupBoxIndex;
                        const object = objectData.intersectsWith[k].objectIndex;
                        objectData.intersectsWith.splice(k, 1);
                        objectData.intersectsWith.push({
                            groupBoxIndex: group,
                            objectIndex: object - 1,
                        });
                        k -= 1;
                        offset += 1;
                    }
                }
            }
        }
    }
    shiftIntersectionsGroupBoxesIndicesFollowingBy(gbIndex) {
        for (const objectData of this.objectsData) {
            let offset = 0;
            for (let k = 0; k < objectData.intersectsWith.length - offset; k += 1) {
                if (objectData.intersectsWith[k].groupBoxIndex > gbIndex) {
                    const group = objectData.intersectsWith[k].groupBoxIndex;
                    const object = objectData.intersectsWith[k].objectIndex;
                    objectData.intersectsWith.splice(k, 1);
                    objectData.intersectsWith.push({
                        groupBoxIndex: group - 1,
                        objectIndex: object,
                    });
                    k -= 1;
                    offset += 1;
                }
            }
        }
    }
    tryToAdd(uuid, boundingBox, orientedBBox, outerBox, normal, { slots, inboundSnapPts, outboundSnapPts }) {
        const newBoundingBox = this.tryToExpand(boundingBox);
        if (!newBoundingBox) {
            return { result: false, objectIndex: 0 };
        }
        this.boundingBox.copy(newBoundingBox);
        this.boundingBox.getSize(this.outerBox.scale);
        this.boundingBox.getCenter(this.outerBox.position);
        this.objectsData.push({
            objectUUID: uuid,
            objectBox: boundingBox,
            orientedBBox,
            normal,
            intersectsWith: [],
            outerBox,
            slots,
            inboundSnapPts,
            outboundSnapPts,
            temporaryExcluded: false,
        });
        return { result: true, objectIndex: this.objectsData.length - 1 };
    }
    clearTemporaryExcluded() {
        for (let i = 0; i < this.objectsData.length; i += 1) {
            this.objectsData[i].temporaryExcluded = false;
        }
    }
    setTemporaryExcluded(excludeIDs) {
        this.objectsData = this.objectsData.map((objectData) => {
            return Object.assign(Object.assign({}, objectData), { temporaryExcluded: excludeIDs.has(objectData.objectUUID) ? true : objectData.temporaryExcluded });
        });
    }
    getGroupBoxMesh() {
        return this.outerBox;
    }
    getGroupBox() {
        return this.boundingBox;
    }
    getObjectsQty() {
        return this.objectsData.length;
    }
    getObjectOuterBox(index) {
        return this.objectsData[index].outerBox;
    }
    getObjBox(index) {
        return this.objectsData[index].objectBox;
    }
    getObjOBB(index) {
        return this.objectsData[index].orientedBBox;
    }
    getObjNormal(index) {
        return this.objectsData[index].normal;
    }
    getSlots(index) {
        return this.objectsData[index].slots;
    }
    getOutboundSnapPts(index) {
        return this.objectsData[index].outboundSnapPts;
    }
    getInboundSnapPts(index) {
        return this.objectsData[index].inboundSnapPts;
    }
    getUUID(index) {
        return this.objectsData[index].objectUUID;
    }
    getObject(index) {
        return this.objectsData[index];
    }
    hasIntersections(index) {
        return this.objectsData[index].intersectsWith.length !== 0;
    }
    getIntersections(index) {
        return this.objectsData[index].intersectsWith;
    }
    findIndexOfInters(index, intersection) {
        let intersIndex = -1;
        for (let i = 0; i < this.objectsData[index].intersectsWith.length; i += 1) {
            if (this.objectsData[index].intersectsWith[i].groupBoxIndex === intersection.groupBoxIndex &&
                this.objectsData[index].intersectsWith[i].objectIndex === intersection.objectIndex) {
                intersIndex = i;
                break;
            }
        }
        return intersIndex;
    }
    removeIntersection(index, intersection) {
        const intersectionIndex = this.findIndexOfInters(index, intersection);
        if (intersectionIndex !== -1) {
            this.objectsData[index].intersectsWith.splice(intersectionIndex, 1);
        }
        if (this.objectsData[index].intersectsWith.length === 0) {
            return true;
        }
        return false;
    }
    removeAllIntersections(index) {
        this.objectsData[index].intersectsWith.length = 0;
    }
    addIntersection(index, collision) {
        this.objectsData[index].intersectsWith.push(collision);
    }
    tryToExpand(newObject) {
        if (this.objectsData.length >= this.maxObjectsContained) {
            return null;
        }
        const newBox = this.boundingBox.clone();
        // expand current group box and store in newBox
        if (newObject.min.x < newBox.min.x) {
            newBox.min.x = newObject.min.x;
        }
        if (newObject.min.y < newBox.min.y) {
            newBox.min.y = newObject.min.y;
        }
        if (newObject.min.z < newBox.min.z) {
            newBox.min.z = newObject.min.z;
        }
        if (newObject.max.x > newBox.max.x) {
            newBox.max.x = newObject.max.x;
        }
        if (newObject.max.y > newBox.max.y) {
            newBox.max.y = newObject.max.y;
        }
        if (newObject.max.z > newBox.max.z) {
            newBox.max.z = newObject.max.z;
        }
        const distance = new three_1.Vector3(0, 0, 0);
        distance.subVectors(newBox.max, newBox.min);
        if (distance.x > this.maxSideSize ||
            distance.y > this.maxSideSize ||
            distance.z > this.maxSideSize ||
            distance.x * distance.y * distance.z > this.maxVolume) {
            return null;
        }
        return newBox;
    }
    testNewVolume(newObject) {
        const newBox = this.tryToExpand(newObject);
        if (newBox === null) {
            return null;
        }
        const size = new three_1.Vector3(0, 0, 0);
        newBox.getSize(size);
        return size.x * size.y * size.z;
    }
    tryToFind(uuid) {
        for (let i = 0; i < this.objectsData.length; i += 1) {
            if (this.objectsData[i].objectUUID === uuid) {
                return i;
            }
        }
        return null;
    }
    removeObject(index) {
        if (index >= this.objectsData.length || index < 0) {
            return false;
        }
        const box2Remove = this.objectsData[index].objectBox.clone();
        this.objectsData.splice(index, 1);
        if (this.objectsData.length === 0) {
            return true;
        }
        return this.updateGBox(box2Remove); // returns true, if the group box has changed it's boundaries
    }
    tryToUpdate(index, boundingBox, orientedBBox, outerBox, normal, { slots, inboundSnapPts, outboundSnapPts }) {
        if (index >= this.objectsData.length || index < 0) {
            console.error('Index Out Of Range error while trying to update object');
            console.error('file: GroupBox function: tryToUpdate()');
            return true; // should not happen, add throw statement here
        }
        const expandedBox = this.tryToExpand(boundingBox);
        if (expandedBox) {
            this.objectsData[index].objectBox = boundingBox;
            this.objectsData[index].outerBox = outerBox;
            this.objectsData[index].orientedBBox = orientedBBox;
            this.objectsData[index].normal = normal;
            this.objectsData[index].slots = slots;
            this.objectsData[index].inboundSnapPts = inboundSnapPts;
            this.objectsData[index].outboundSnapPts = outboundSnapPts;
            this.updateGBox(boundingBox, true);
            return true;
        }
        return false;
    }
    isEmpty() {
        return this.objectsData.length === 0;
    }
    containsPoint(point) {
        return this.boundingBox.containsPoint(point);
    }
    testIntersection(object, orientedBBox, { excludeIDs = new Set(), precision = 0.001, firstFoundCollisionOnly = false, useObbInsteadOfMeshCollision = false, } = {}) {
        const res = { result: false, objects: [] };
        const scene = (0, utils_3d_1.getSceneFromObject)(object);
        if (!orientedBBox.intersectsBox3(this.boundingBox) || !scene) {
            return res;
        }
        orientedBBox.halfSize.subScalar(precision * 2);
        for (let i = 0; i < this.objectsData.length; i += 1) {
            let hasIntersection = false;
            if (!excludeIDs.has(this.objectsData[i].objectUUID)) {
                const toObject = (0, utils_3d_1.getObjectByUUID)(scene, this.getUUID(i));
                if (!toObject) {
                    continue;
                }
                // Broad phase: skip the expensive mesh test for objects whose boxes don't even overlap
                if (!useObbInsteadOfMeshCollision &&
                    !orientedBBox.intersectsOBB(this.getObjOBB(i), consts_1.consts.STANDARD_PRECISION)) {
                    continue;
                }
                if (useObbInsteadOfMeshCollision) {
                    hasIntersection = orientedBBox.intersectsOBB(this.getObjOBB(i), consts_1.consts.STANDARD_PRECISION);
                }
                else if (([object, toObject].some((obj) => (0, utils_3d_1.isExtrusion)(obj)) &&
                    [object, toObject].some((obj) => obj.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET)) ||
                    [object, toObject].every((obj) => obj.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET)) {
                    hasIntersection = GroupBox.testIntersectionForGasket(object, toObject, precision);
                }
                else if (isPlasticPanelAndOrthogonalExtrusionPair(object, toObject)) {
                    hasIntersection = false;
                }
                else if (object.cutContour.length || toObject.cutContour.length) {
                    hasIntersection = GroupBox.testIntersectionForPanelContours(object, toObject, precision);
                }
                else if (utils_1.Utils.areEqual(object.scalingAngle, 0) && utils_1.Utils.areEqual(toObject.scalingAngle, 0)) {
                    hasIntersection = object.testIntersection(toObject);
                }
                else {
                    hasIntersection =
                        object.scalingAngle !== 0
                            ? GroupBox.testIntersectionForAngledExtrusion(object, toObject, precision)
                            : GroupBox.testIntersectionForAngledExtrusion(toObject, object, precision);
                }
            }
            if (hasIntersection) {
                res.objects.push(i);
                res.result = true;
                if (firstFoundCollisionOnly) {
                    break;
                }
            }
        }
        return res;
    }
    static testIntersectionForGasket(fromObject, toObject, precision) {
        const scene = (0, utils_3d_1.getSceneFromObject)(fromObject);
        if (!scene) {
            return fromObject.testIntersection(toObject);
        }
        const bothGaskets = [fromObject, toObject].every((obj) => obj.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET);
        const gasket = [fromObject, toObject].find((object) => object.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET);
        const toCheckObject = bothGaskets
            ? [fromObject, toObject]
                .filter((object) => object.uuid !== (gasket === null || gasket === void 0 ? void 0 : gasket.uuid))
                .find((object) => object.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET)
            : [fromObject, toObject].find((object) => (0, utils_3d_1.isExtrusion)(object));
        if (!gasket || !toCheckObject) {
            throw new Error('Invalid arguments. Should be both gaskets or one extrusion and one gasket items.');
        }
        const panelItem = gasket.connectedItems.find((item) => item.itemType === types_1.ITEM_TYPE.PANEL);
        if (!panelItem) {
            return (0, utils_3d_1.areNotEqual)(toCheckObject.scalingAngle, 0)
                ? GroupBox.testIntersectionForAngledExtrusion(toCheckObject, gasket, precision)
                : fromObject.testIntersection(toObject);
        }
        const panel = (0, utils_3d_1.getObjectByUUID)(scene, panelItem.uuid);
        if (!bothGaskets && panel.connectedItems.some((item) => item.uuid === toCheckObject.uuid)) {
            return false;
        }
        if (bothGaskets &&
            panel.connectedItems.some((item) => toCheckObject.connectedItems.some((gasketConnectedItem) => gasketConnectedItem.uuid === item.uuid))) {
            return false;
        }
        return (0, utils_3d_1.areNotEqual)(toCheckObject.scalingAngle, 0)
            ? GroupBox.testIntersectionForAngledExtrusion(toCheckObject, gasket, precision)
            : fromObject.testIntersection(toObject);
    }
    static testIntersectionForPanelContours(fromObject, toObject, precision) {
        const panel = fromObject.cutContour.length > 0 ? fromObject : toObject;
        const object = panel === fromObject ? toObject : fromObject;
        if (object.scalingAngle !== 0) {
            return GroupBox.testIntersectionForAngledExtrusion(object, panel, precision);
        }
        const checkLines = (0, PanelInSlotsUtils_1.getPanelEdges)(panel);
        const ray = new three_1.Raycaster();
        const tempVector1 = new three_1.Vector3();
        const tempVector2 = new three_1.Vector3();
        let hasIntersection = false;
        checkLines.forEach((line) => {
            if (hasIntersection) {
                return;
            }
            ray.set(line.start, tempVector1.subVectors(line.end, line.start).normalize());
            ray.far = tempVector2.subVectors(line.end, line.start).length();
            const intersections = (0, utils_3d_1.getRayIntersectionsWithMeshGeometry)(ray, object);
            hasIntersection = intersections.length > 0;
            // do not check collisions for part of fastener over angled extrusion
            if (hasIntersection &&
                utils_1.Utils.isFastener(object) &&
                object.connectedItems.some((item) => item.connectionExtrusionAngle && item.connectionExtrusionAngle !== 0)) {
                hasIntersection = false;
            }
        });
        return hasIntersection;
    }
    static testIntersectionForAngledExtrusion(fromObject, toObject, precision) {
        const result = [];
        const recalculateEndFacePoints = (points) => {
            const offset = consts_1.consts.END_FACE_CORNERS_OFFSET;
            const resPoints = [];
            const topLine = new three_1.Line3(points[0], points[1]);
            const bottomLine = new three_1.Line3(points[2], points[3]);
            const rightLeftShiftedPoints = [
                topLine.at(offset, new three_1.Vector3()),
                topLine.at(1 - offset, new three_1.Vector3()),
                bottomLine.at(offset, new three_1.Vector3()),
                bottomLine.at(1 - offset, new three_1.Vector3()),
            ];
            const leftLine = new three_1.Line3(rightLeftShiftedPoints[1], rightLeftShiftedPoints[2]);
            const rightLine = new three_1.Line3(rightLeftShiftedPoints[0], rightLeftShiftedPoints[3]);
            resPoints.push(rightLine.at(offset, new three_1.Vector3()), leftLine.at(offset, new three_1.Vector3()), leftLine.at(1 - offset, new three_1.Vector3()), rightLine.at(1 - offset, new three_1.Vector3()));
            [
                new three_1.Line3(resPoints[0], resPoints[1]),
                new three_1.Line3(resPoints[2], resPoints[3]),
                new three_1.Line3(resPoints[1], resPoints[2]),
                new three_1.Line3(resPoints[0], resPoints[3]),
                new three_1.Line3(resPoints[1], resPoints[3]),
            ].forEach((line) => resPoints.push(line.at(0.25, new three_1.Vector3()), line.at(0.5, new three_1.Vector3()), line.at(0.75, new three_1.Vector3())));
            return resPoints;
        };
        let directionNormal = fromObject.directionNormal.clone();
        const endFacesPoints = fromObject.selectionBox.vertices.map((vertex) => vertex.clone());
        const toObjectOBB = (0, utils_3d_1.getOBB)(toObject);
        for (let endFaceIndex = 0; endFaceIndex < 2; endFaceIndex += 1) {
            if (endFaceIndex === 1) {
                directionNormal = directionNormal.negate();
            }
            const offset = directionNormal.clone().multiplyScalar(precision);
            const initialEndFacePoints = endFacesPoints.splice(0, 4).map((p) => p.add(offset));
            if (initialEndFacePoints.length !== 4) {
                return false;
            }
            const endFacePoints = recalculateEndFacePoints(initialEndFacePoints);
            let hasIntersection = false;
            for (let i = 0; i < endFacePoints.length; i += 1) {
                const raycaster = new three_1.Raycaster(endFacePoints[i], directionNormal.clone());
                const intersections = (0, utils_3d_1.getRayIntersectionsWithMeshGeometry)(raycaster, toObject);
                if (intersections.length || (!toObject.cutContour.length && toObjectOBB.containsPoint(endFacePoints[i]))) {
                    hasIntersection = true;
                    break;
                }
            }
            result.push(hasIntersection);
        }
        return result.every(Boolean);
    }
    getClosest(object, direction, excludeIDs = new Set()) {
        let testResult = false;
        let objectIndex = -1;
        let toObjectId = '';
        const minDistToObject = { distance: Infinity };
        const scene = (0, utils_3d_1.getSceneFromObject)(object);
        if (!scene) {
            return { result: testResult, objIndex: objectIndex, distance: minDistToObject.distance, uuid: toObjectId };
        }
        this.objectsData.forEach((objectData, objectDataIndex) => {
            const objectId = objectData.objectUUID;
            const toObject = (0, utils_3d_1.getObjectByUUID)(scene, objectId);
            if (excludeIDs.has(objectId) || !toObject || !(0, utils_3d_1.checkCollisionExists)(object, toObject, direction)) {
                return;
            }
            const toObjectSlots = this.getSlots(objectDataIndex);
            const distToObject = (0, utils_3d_1.getDistanceToObject)(object, toObject, toObjectSlots, direction);
            if ((distToObject === null || distToObject === void 0 ? void 0 : distToObject.distance) && distToObject.distance < minDistToObject.distance) {
                testResult = true;
                minDistToObject.distance = distToObject.distance;
                minDistToObject.slot = distToObject.slot;
                toObjectId = toObject.uuid;
                objectIndex = objectDataIndex;
            }
        });
        const { distance, slot } = minDistToObject;
        return { result: testResult, objIndex: objectIndex, distance, uuid: toObjectId, slot };
    }
    updateGBox(box, fullUpdate = false) {
        const objMin = box.min.clone();
        const objMax = box.max.clone();
        let updated = false;
        if ((0, utils_3d_1.areEqual)(this.boundingBox.min.x, objMin.x) || fullUpdate) {
            let newX = this.objectsData[0].objectBox.min.x;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.min.x < newX) {
                    newX = this.objectsData[i].objectBox.min.x;
                }
            }
            this.boundingBox.min.setX(newX);
            updated = true;
        }
        if ((0, utils_3d_1.areEqual)(this.boundingBox.min.y, objMin.y) || fullUpdate) {
            let newY = this.objectsData[0].objectBox.min.y;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.min.y < newY) {
                    newY = this.objectsData[i].objectBox.min.y;
                }
            }
            this.boundingBox.min.setY(newY);
            updated = true;
        }
        if ((0, utils_3d_1.areEqual)(this.boundingBox.min.z, objMin.z) || fullUpdate) {
            let newZ = this.objectsData[0].objectBox.min.z;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.min.z < newZ) {
                    newZ = this.objectsData[i].objectBox.min.z;
                }
            }
            this.boundingBox.min.setZ(newZ);
            updated = true;
        }
        if ((0, utils_3d_1.areEqual)(this.boundingBox.max.x, objMax.x) || fullUpdate) {
            let newX = this.objectsData[0].objectBox.max.x;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.max.x > newX) {
                    newX = this.objectsData[i].objectBox.max.x;
                }
            }
            this.boundingBox.max.setX(newX);
            updated = true;
        }
        if ((0, utils_3d_1.areEqual)(this.boundingBox.max.y, objMax.y) || fullUpdate) {
            let newY = this.objectsData[0].objectBox.max.y;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.max.y > newY) {
                    newY = this.objectsData[i].objectBox.max.y;
                }
            }
            this.boundingBox.max.setY(newY);
            updated = true;
        }
        if ((0, utils_3d_1.areEqual)(this.boundingBox.max.z, objMax.z) || fullUpdate) {
            let newZ = this.objectsData[0].objectBox.max.z;
            for (let i = 1; i < this.objectsData.length; i += 1) {
                if (this.objectsData[i].objectBox.max.z > newZ) {
                    newZ = this.objectsData[i].objectBox.max.z;
                }
            }
            this.boundingBox.max.setZ(newZ);
            updated = true;
        }
        this.boundingBox.getSize(this.outerBox.scale);
        this.boundingBox.getCenter(this.outerBox.position);
        return updated;
    }
    testEdgeSnap(position, direction, threshold, exclude = new Set()) {
        const epsilon = 1e-8;
        let testResult = false;
        const dir = direction.clone().multiply(direction);
        const snapObjects = [];
        let dist;
        const originAxis = position.clone().dot(dir);
        let boxMin = this.boundingBox.min.clone().multiply(dir);
        let minAxis = boxMin.x + boxMin.y + boxMin.z;
        let boxMax = this.boundingBox.max.clone().multiply(dir);
        let maxAxis = boxMax.x + boxMax.y + boxMax.z;
        if (originAxis < minAxis - threshold || originAxis > maxAxis + threshold) {
            return { result: false, snappedObjects: [] };
        }
        for (let i = 0; i < this.objectsData.length; i += 1) {
            const testObject = this.objectsData[i].outerBox.parent;
            if (exclude.has(this.objectsData[i].objectUUID) || !testObject.isSnappable) {
                continue;
            }
            boxMin = this.objectsData[i].objectBox.min.clone().multiply(dir);
            minAxis = boxMin.x + boxMin.y + boxMin.z;
            boxMax = this.objectsData[i].objectBox.max.clone().multiply(dir);
            maxAxis = boxMax.x + boxMax.y + boxMax.z;
            if (Math.abs(minAxis - originAxis) - threshold <= epsilon) {
                dist = minAxis - originAxis;
                testResult = true;
                snapObjects.push({
                    objectUUID: this.objectsData[i].objectUUID,
                    distance: dist,
                });
            }
            else if (Math.abs(maxAxis - originAxis) - threshold <= epsilon) {
                dist = maxAxis - originAxis;
                testResult = true;
                snapObjects.push({
                    objectUUID: this.objectsData[i].objectUUID,
                    distance: dist,
                });
            }
        }
        return { result: testResult, snappedObjects: snapObjects };
    }
    testBoxSnap(box, dir, halfSize, slots, snapPts, threshold, excludeIDs = new Set()) {
        let testResult = false;
        const numOfNonOverlappingDims = utils_1.Utils.GetNonOverlappingBoxesDimensionsCount(box, this.boundingBox, threshold);
        if (numOfNonOverlappingDims > 1) {
            return {
                result: false,
                snapValues: null,
                snapMask: null,
                snappedIndices: null,
                snappedDirs: null,
                dist2Snap: null,
                xSlots: null,
                xPoints: null,
                ySlots: null,
                yPoints: null,
                zSlots: null,
                zPoints: null,
            };
        }
        this.clearTemporaryExcluded();
        this.setTemporaryExcluded(excludeIDs);
        const boxCenter = new three_1.Vector3();
        box.getCenter(boxCenter);
        const newPosition = boxCenter.clone();
        const mask = new three_1.Vector3();
        const dist = new three_1.Vector3();
        const minDist = new three_1.Vector3();
        const minSnapDiff = new three_1.Vector3();
        const snappedIndices = new three_1.Vector3();
        const snappedDirX = new three_1.Vector3();
        const snappedDirY = new three_1.Vector3();
        const snappedDirZ = new three_1.Vector3();
        const xSlots = [];
        const xPoints = [];
        const ySlots = [];
        const yPoints = [];
        const zSlots = [];
        const zPoints = [];
        const sign = dir.x + dir.y + dir.z;
        const dirABS = dir.clone().multiply(dir);
        let bottomSurfaceCoord;
        let topSurfaceCoord;
        if (sign > 0) {
            bottomSurfaceCoord = box.min.clone().dot(dirABS);
        }
        else {
            bottomSurfaceCoord = box.max.clone().dot(dirABS);
        }
        let i = 0;
        for (const objectData of this.objectsData) {
            const neighborObject = objectData.outerBox.parent;
            if (objectData.temporaryExcluded || !neighborObject.isSnappable || utils_1.Utils.isFastener(neighborObject)) {
                continue;
            }
            if (box.clone().expandByScalar(-consts_1.consts.COLLISION_BOX_PADDING).intersectsBox(objectData.objectBox)) {
                continue;
            }
            if ((0, utils_3d_1.areVectorsCollinear)(dir, objectData.normal)) {
                if (sign > 0) {
                    topSurfaceCoord = objectData.objectBox.max.clone().dot(dirABS);
                }
                else {
                    topSurfaceCoord = objectData.objectBox.min.clone().dot(dirABS);
                }
                if ((0, utils_3d_1.areEqual)(topSurfaceCoord - bottomSurfaceCoord, 0)) {
                    continue;
                }
            }
            const currentBoxCenter = new three_1.Vector3(0, 0, 0);
            objectData.objectBox.getCenter(currentBoxCenter);
            const halfSizeCurrent = new three_1.Vector3(0, 0, 0);
            halfSizeCurrent.x = Math.abs((objectData.objectBox.max.x - objectData.objectBox.min.x) / 2);
            halfSizeCurrent.y = Math.abs((objectData.objectBox.max.y - objectData.objectBox.min.y) / 2);
            halfSizeCurrent.z = Math.abs((objectData.objectBox.max.z - objectData.objectBox.min.z) / 2);
            if ((0, utils_3d_1.areEqual)(dirABS.x, 0)) {
                let hasIntersection = true;
                const distVec = box.max.z <= objectData.objectBox.min.z ||
                    (0, utils_3d_1.areEqual)(box.max.z, objectData.objectBox.min.z) ||
                    box.min.z >= objectData.objectBox.max.z ||
                    (0, utils_3d_1.areEqual)(box.min.z, objectData.objectBox.max.z)
                    ? new three_1.Vector3(0, 0, 1).multiplyScalar(boxCenter.z - currentBoxCenter.z > 0 ? 1 : -1)
                    : new three_1.Vector3(0, 1, 0).multiplyScalar(boxCenter.y - currentBoxCenter.y > 0 ? 1 : -1);
                const distVecABS = distVec.clone().multiply(distVec);
                if (distVec.y === 0) {
                    if (box.min.y > objectData.objectBox.max.y ||
                        box.max.y < objectData.objectBox.min.y ||
                        box.min.x > objectData.objectBox.max.x ||
                        box.max.x < objectData.objectBox.min.x) {
                        hasIntersection = false;
                    }
                }
                if (hasIntersection) {
                    const axisVec = new three_1.Vector3(1, 0, 0);
                    const diffDist = boxCenter.clone().sub(currentBoxCenter).dot(distVecABS);
                    dist.setX(Math.abs(diffDist) - halfSizeCurrent.dot(distVecABS) - halfSize.dot(distVecABS));
                    const test = GroupBox.testAxisSnap(distVec, axisVec, minSnapDiff.x, boxCenter, threshold, { slots, snappingPoints: snapPts }, { slots: objectData.slots, snappingPoints: objectData.inboundSnapPts });
                    if (test.result &&
                        ((0, utils_3d_1.less)(test.minSnapDiff, minSnapDiff.x, consts_1.consts.TWO_FLOAT_EPSILON) ||
                            (0, utils_3d_1.areEqual)(test.minSnapDiff, minSnapDiff.x, consts_1.consts.TWO_FLOAT_EPSILON) ||
                            (0, utils_3d_1.areEqual)(mask.x, 0))) {
                        snappedIndices.setX(i);
                        newPosition.setX(test.axisSnapValue);
                        snappedDirX.copy(distVec);
                        if (dist.x < minDist.x || mask.x === 0) {
                            minDist.x = dist.x;
                            mask.setX(diffDist > 0 ? 1 : -1);
                        }
                        minSnapDiff.x = test.minSnapDiff;
                        testResult = true;
                        if ((0, utils_3d_1.areNotEqual)(test.minSnapDiff, minSnapDiff.x)) {
                            xSlots.length = 0;
                            xPoints.length = 0;
                        }
                        xSlots.push(...test.snapSlots);
                        xPoints.push(...test.snapPoints);
                        xSlots.push(...test.currentSlotsResult);
                        xPoints.push(...test.currentPointsResult);
                    }
                }
            }
            if ((0, utils_3d_1.areEqual)(dirABS.y, 0)) {
                let hasIntersection = true;
                const distVec = box.max.z < objectData.objectBox.min.z ||
                    (0, utils_3d_1.areEqual)(box.max.z, objectData.objectBox.min.z) ||
                    box.min.z > objectData.objectBox.max.z ||
                    (0, utils_3d_1.areEqual)(box.min.z, objectData.objectBox.max.z)
                    ? new three_1.Vector3(0, 0, 1).multiplyScalar(boxCenter.z - currentBoxCenter.z > 0 ? 1 : -1)
                    : new three_1.Vector3(1, 0, 0).multiplyScalar(boxCenter.x - currentBoxCenter.x > 0 ? 1 : -1);
                const distVecABS = distVec.clone().multiply(distVec);
                if (distVec.x === 0) {
                    if (box.min.y > objectData.objectBox.max.y ||
                        box.max.y < objectData.objectBox.min.y ||
                        box.min.x > objectData.objectBox.max.x ||
                        box.max.x < objectData.objectBox.min.x) {
                        hasIntersection = false;
                    }
                }
                if (hasIntersection) {
                    const axisVec = new three_1.Vector3(0, 1, 0);
                    const diffDist = boxCenter.clone().sub(currentBoxCenter).dot(distVecABS);
                    dist.setY(Math.abs(diffDist) - halfSizeCurrent.dot(distVecABS) - halfSize.dot(distVecABS));
                    const test = GroupBox.testAxisSnap(distVec, axisVec, minSnapDiff.y, boxCenter, threshold, { slots, snappingPoints: snapPts }, { slots: objectData.slots, snappingPoints: objectData.inboundSnapPts });
                    if (test.result &&
                        (test.minSnapDiff < minSnapDiff.y ||
                            (0, utils_3d_1.areEqual)(test.minSnapDiff, minSnapDiff.y, consts_1.consts.TWO_FLOAT_EPSILON) ||
                            (0, utils_3d_1.areEqual)(mask.y, 0))) {
                        snappedIndices.setY(i);
                        newPosition.setY(test.axisSnapValue);
                        snappedDirY.copy(distVec);
                        if (dist.y < minDist.y || mask.y === 0) {
                            minDist.y = dist.y;
                            mask.setY(diffDist > 0 ? 1 : -1);
                        }
                        minSnapDiff.y = test.minSnapDiff;
                        testResult = true;
                        if ((0, utils_3d_1.areNotEqual)(test.minSnapDiff, minSnapDiff.y)) {
                            ySlots.length = 0;
                            yPoints.length = 0;
                        }
                        ySlots.push(...test.snapSlots);
                        yPoints.push(...test.snapPoints);
                        ySlots.push(...test.currentSlotsResult);
                        yPoints.push(...test.currentPointsResult);
                    }
                }
            }
            if ((0, utils_3d_1.areEqual)(dirABS.z, 0)) {
                const distVec = (box.min.y > objectData.objectBox.min.y && box.min.y < objectData.objectBox.max.y) ||
                    (box.max.y > objectData.objectBox.min.y && box.max.y < objectData.objectBox.max.y)
                    ? new three_1.Vector3(0, 1, 0).multiplyScalar(boxCenter.y - currentBoxCenter.y > 0 ? 1 : -1)
                    : new three_1.Vector3(1, 0, 0).multiplyScalar(boxCenter.x - currentBoxCenter.x > 0 ? 1 : -1);
                const axisVec = new three_1.Vector3(0, 0, 1);
                const diffDist = boxCenter.clone().sub(currentBoxCenter).dot(distVec);
                dist.setZ(Math.abs(diffDist) - halfSizeCurrent.dot(distVec) - halfSize.dot(distVec));
                if (dist.z < minDist.z || (0, utils_3d_1.areEqual)(mask.z, 0)) {
                    const test = GroupBox.testAxisSnap(distVec, axisVec, minSnapDiff.z, boxCenter, threshold, { slots, snappingPoints: snapPts }, { slots: objectData.slots, snappingPoints: objectData.inboundSnapPts });
                    if (test.result &&
                        (test.minSnapDiff < minSnapDiff.z ||
                            (0, utils_3d_1.areEqual)(test.minSnapDiff, minSnapDiff.z, consts_1.consts.TWO_FLOAT_EPSILON) ||
                            (0, utils_3d_1.areEqual)(mask.z, 0))) {
                        snappedIndices.setZ(i);
                        newPosition.setZ(test.axisSnapValue);
                        snappedDirZ.copy(distVec);
                        if (dist.z < minDist.z || mask.z === 0) {
                            minDist.z = dist.z;
                            mask.setZ(diffDist > 0 ? 1 : -1);
                        }
                        minSnapDiff.z = test.minSnapDiff;
                        testResult = true;
                        if ((0, utils_3d_1.areNotEqual)(test.minSnapDiff, minSnapDiff.z)) {
                            zSlots.length = 0;
                            zPoints.length = 0;
                        }
                        zSlots.push(...test.snapSlots);
                        zPoints.push(...test.snapPoints);
                        zSlots.push(...test.currentSlotsResult);
                        zPoints.push(...test.currentPointsResult);
                    }
                }
            }
            i += 1;
        }
        return {
            result: testResult,
            snapValues: newPosition,
            snapMask: mask,
            snappedIndices,
            snappedDirs: { xSnap: snappedDirX, ySnap: snappedDirY, zSnap: snappedDirZ },
            dist2Snap: minDist,
            xSlots,
            xPoints,
            ySlots,
            yPoints,
            zSlots,
            zPoints,
        };
    }
    static testAxisSnap(distVec, axisVec, alreadyCalculatedOffset, centerPos, threshold, objectSlotsAndSnappingPoints, neighborSlotsAndSnappingPoints) {
        const { slots: objectSlots, snappingPoints: objectSnapPts } = objectSlotsAndSnappingPoints;
        const { slots: neighborSlots, snappingPoints: neighborSnapPts } = neighborSlotsAndSnappingPoints;
        let testResult = false;
        let axisSnapValue = 0;
        let snapSlotsResult = [];
        let snapPointsResult = [];
        let currentSlotsResult = [];
        let currentPointsResult = [];
        const isSlot = false;
        const isPoint = true;
        const snapSlots = objectSlots.filter((slot) => (0, utils_3d_1.areVectorsEqual)(slot.normal, distVec.clone().negate(), consts_1.consts.TWO_FLOAT_EPSILON) &&
            !(0, utils_3d_1.areVectorsCollinear)(axisVec, slot.direction));
        const snapPoints = objectSnapPts.filter((snapPt) => (0, utils_3d_1.areVectorsEqual)(snapPt.normal, distVec.clone().negate()));
        let snapAnchors;
        let snapAnchorType = isSlot;
        if (snapSlots.length) {
            snapAnchors = snapSlots;
        }
        else {
            snapAnchors = snapPoints;
            snapAnchorType = isPoint;
        }
        const currentSlotsToCheck = neighborSlots.filter((slot) => (0, utils_3d_1.areVectorsEqual)(slot.normal, distVec, consts_1.consts.TWO_FLOAT_EPSILON) &&
            !(0, utils_3d_1.areVectorsCollinear)(axisVec, slot.direction));
        const currentPointsToCheck = neighborSnapPts.filter((snapPt) => (0, utils_3d_1.areVectorsEqual)(snapPt.normal, distVec));
        let currentAnchors;
        let currentAnchorType = isSlot;
        if (currentSlotsToCheck.length) {
            currentAnchors = currentSlotsToCheck;
        }
        else {
            currentAnchors = currentPointsToCheck;
            currentAnchorType = isPoint;
        }
        let minSnapDiff = 0;
        let mayUpdateSlot = true;
        for (let anchorIndx = 0; anchorIndx < snapAnchors.length; anchorIndx += 1) {
            for (let currAnchorIndx = 0; currAnchorIndx < currentAnchors.length; currAnchorIndx += 1) {
                const originDiff = snapAnchors[anchorIndx].origin
                    .clone()
                    .sub(currentAnchors[currAnchorIndx].origin)
                    .dot(axisVec);
                // in case when part is positioned between two parts we need to have only one direction of the snap
                if ((0, utils_3d_1.areNotEqual)(originDiff, alreadyCalculatedOffset, consts_1.consts.TWO_FLOAT_EPSILON) &&
                    originDiff * alreadyCalculatedOffset < 0) {
                    continue;
                }
                if (Math.abs(originDiff) < threshold ||
                    (0, utils_3d_1.areEqual)(Math.abs(originDiff), threshold, consts_1.consts.TWO_FLOAT_EPSILON) ||
                    (0, utils_3d_1.areEqual)(Math.abs(originDiff), 0, consts_1.consts.TWO_FLOAT_EPSILON)) {
                    if ((0, utils_3d_1.areEqual)(originDiff, minSnapDiff, consts_1.consts.TWO_FLOAT_EPSILON) && !mayUpdateSlot) {
                        if (snapAnchorType === isSlot) {
                            snapSlotsResult.push(snapAnchors[anchorIndx]);
                        }
                        else {
                            snapPointsResult.push(snapAnchors[anchorIndx]);
                        }
                        if (currentAnchorType === isSlot) {
                            currentSlotsResult.push(currentAnchors[currAnchorIndx]);
                        }
                        else {
                            currentPointsResult.push(currentAnchors[currAnchorIndx]);
                        }
                    }
                    else if ((0, utils_3d_1.less)(Math.abs(originDiff), Math.abs(minSnapDiff), consts_1.consts.TWO_FLOAT_EPSILON) || mayUpdateSlot) {
                        snapSlotsResult.length = 0;
                        snapPointsResult.length = 0;
                        currentSlotsResult.length = 0;
                        currentPointsResult.length = 0;
                        minSnapDiff = originDiff;
                        axisSnapValue = currentAnchors[currAnchorIndx].origin
                            .clone()
                            .add(centerPos.clone().sub(snapAnchors[anchorIndx].origin))
                            .dot(axisVec);
                        testResult = true;
                        mayUpdateSlot = false;
                        if (snapAnchorType === isSlot) {
                            snapSlotsResult.push(snapAnchors[anchorIndx]);
                        }
                        else {
                            snapPointsResult.push(snapAnchors[anchorIndx]);
                        }
                        if (currentAnchorType === isSlot) {
                            currentSlotsResult.push(currentAnchors[currAnchorIndx]);
                        }
                        else {
                            currentPointsResult.push(currentAnchors[currAnchorIndx]);
                        }
                    }
                }
            }
        }
        const buffer = [];
        if (testResult === true) {
            for (let i = 0; i < snapSlotsResult.length; i += 1) {
                for (let k = 0; k < objectSlots.length; k += 1) {
                    if ((0, utils_3d_1.areVectorsEqual)(snapSlotsResult[i].direction, objectSlots[k].direction) &&
                        (0, utils_3d_1.areEqual)(snapSlotsResult[i].length, objectSlots[k].length) &&
                        (0, utils_3d_1.areVectorsEqual)(snapSlotsResult[i].normal, objectSlots[k].normal) &&
                        (0, utils_3d_1.areVectorsEqual)(snapSlotsResult[i].origin, objectSlots[k].origin) &&
                        (0, utils_3d_1.areEqual)(snapSlotsResult[i].slotNumber, objectSlots[k].slotNumber) &&
                        (0, utils_3d_1.areVectorsEqual)(snapSlotsResult[i].surfacePoint, objectSlots[k].surfacePoint) &&
                        (0, utils_3d_1.areEqual)(snapSlotsResult[i].width, objectSlots[k].width)) {
                        snapSlotsResult[i] = objectSlots[k];
                        break;
                    }
                }
                // eslint-disable-next-line no-loop-func
                if (!buffer.some((current) => (0, utils_3d_1.areVectorsEqual)(current.origin, snapSlotsResult[i].origin))) {
                    buffer.push(snapSlotsResult[i]);
                }
            }
            snapSlotsResult.length = 0;
            snapSlotsResult = snapSlotsResult.concat(buffer);
            buffer.length = 0;
            for (let i = 0; i < snapPointsResult.length; i += 1) {
                for (let k = 0; k < objectSnapPts.length; k += 1) {
                    if ((0, utils_3d_1.areVectorsEqual)(snapPointsResult[i].normal, objectSnapPts[k].normal) &&
                        (0, utils_3d_1.areVectorsEqual)(snapPointsResult[i].origin, objectSnapPts[k].origin)) {
                        snapPointsResult[i] = objectSnapPts[k];
                        break;
                    }
                }
                // eslint-disable-next-line no-loop-func
                if (!buffer.some((current) => (0, utils_3d_1.areVectorsEqual)(current.origin, snapPointsResult[i].origin))) {
                    buffer.push(snapPointsResult[i]);
                }
            }
            snapPointsResult.length = 0;
            snapPointsResult = snapPointsResult.concat(buffer);
            buffer.length = 0;
            for (let i = 0; i < currentSlotsResult.length; i += 1) {
                for (let k = 0; k < neighborSlots.length; k += 1) {
                    if ((0, utils_3d_1.areVectorsEqual)(currentSlotsResult[i].direction, neighborSlots[k].direction) &&
                        (0, utils_3d_1.areEqual)(currentSlotsResult[i].length, neighborSlots[k].length) &&
                        (0, utils_3d_1.areVectorsEqual)(currentSlotsResult[i].normal, neighborSlots[k].normal) &&
                        (0, utils_3d_1.areVectorsEqual)(currentSlotsResult[i].origin, neighborSlots[k].origin) &&
                        (0, utils_3d_1.areEqual)(currentSlotsResult[i].slotNumber, neighborSlots[k].slotNumber) &&
                        (0, utils_3d_1.areVectorsEqual)(currentSlotsResult[i].surfacePoint, neighborSlots[k].surfacePoint) &&
                        (0, utils_3d_1.areEqual)(currentSlotsResult[i].width, neighborSlots[k].width)) {
                        currentSlotsResult[i] = neighborSlots[k];
                        break;
                    }
                }
                // eslint-disable-next-line no-loop-func
                if (!buffer.some((current) => (0, utils_3d_1.areVectorsEqual)(current.origin, currentSlotsResult[i].origin))) {
                    buffer.push(currentSlotsResult[i]);
                }
            }
            currentSlotsResult.length = 0;
            currentSlotsResult = currentSlotsResult.concat(buffer);
            buffer.length = 0;
            for (let i = 0; i < currentPointsResult.length; i += 1) {
                for (let k = 0; k < objectSnapPts.length; k += 1) {
                    if ((0, utils_3d_1.areVectorsEqual)(currentPointsResult[i].normal, neighborSnapPts[k].normal) &&
                        (0, utils_3d_1.areVectorsEqual)(currentPointsResult[i].origin, neighborSnapPts[k].origin)) {
                        currentPointsResult[i] = neighborSnapPts[k];
                        break;
                    }
                }
                // eslint-disable-next-line no-loop-func
                if (!buffer.some((current) => (0, utils_3d_1.areVectorsEqual)(current.origin, currentPointsResult[i].origin))) {
                    buffer.push(currentPointsResult[i]);
                }
            }
            currentPointsResult.length = 0;
            currentPointsResult = currentPointsResult.concat(buffer);
        }
        return {
            result: testResult,
            axisSnapValue,
            minSnapDiff,
            snapSlots: snapSlotsResult,
            snapPoints: snapPointsResult,
            currentSlotsResult,
            currentPointsResult,
        };
    }
    snapObjectByBoundingBox(object, movementDirection, excludeIDs, threshold) {
        if (!object) {
            return;
        }
        const bbox = utils_1.Utils.getAABBox(object);
        const offset = new three_1.Vector3();
        for (const objectData of this.objectsData) {
            const neighborObject = Viewer_1.default.instance.getObjectById(objectData.objectUUID);
            if ((neighborObject && !neighborObject.isSnappable) || excludeIDs.includes(objectData.objectUUID)) {
                continue;
            }
            if (isPlasticPanelAndOrthogonalExtrusionPair(object, neighborObject)) {
                continue;
            }
            if (!bbox.intersectsBox(objectData.objectBox)) {
                continue;
            }
            if ((0, utils_3d_1.areNotEqual)(movementDirection.x, 0.0)) {
                const deltaXFromBelow = objectData.objectBox.max.x - bbox.min.x;
                const deltaXFromAbove = objectData.objectBox.min.x - bbox.max.x;
                if (bbox.min.x < objectData.objectBox.max.x &&
                    bbox.min.x > objectData.objectBox.min.x &&
                    Math.abs(deltaXFromBelow) < threshold) {
                    offset.x = deltaXFromBelow;
                }
                else if (bbox.max.x > objectData.objectBox.min.x &&
                    bbox.max.x < objectData.objectBox.max.x &&
                    Math.abs(deltaXFromAbove) < threshold) {
                    offset.x = deltaXFromAbove;
                }
            }
            if ((0, utils_3d_1.areNotEqual)(movementDirection.y, 0.0)) {
                const deltaYFromBelow = objectData.objectBox.max.y - bbox.min.y;
                const deltaYFromAbove = objectData.objectBox.min.y - bbox.max.y;
                if (bbox.min.y < objectData.objectBox.max.y &&
                    bbox.min.y > objectData.objectBox.min.y &&
                    Math.abs(deltaYFromBelow) < threshold) {
                    offset.y = deltaYFromBelow;
                }
                else if (bbox.max.y > objectData.objectBox.min.y &&
                    bbox.max.y < objectData.objectBox.max.y &&
                    Math.abs(deltaYFromAbove) < threshold) {
                    offset.y = deltaYFromAbove;
                }
            }
            if ((0, utils_3d_1.areNotEqual)(movementDirection.z, 0.0)) {
                const deltaZFromBelow = objectData.objectBox.max.z - bbox.min.z;
                const deltaZFromAbove = objectData.objectBox.min.z - bbox.max.z;
                if (bbox.min.z < objectData.objectBox.max.z &&
                    bbox.min.z > objectData.objectBox.min.z &&
                    Math.abs(deltaZFromBelow) < threshold) {
                    offset.z = deltaZFromBelow;
                }
                else if (bbox.max.z > objectData.objectBox.min.z &&
                    bbox.max.z < objectData.objectBox.max.z &&
                    Math.abs(deltaZFromAbove) < threshold) {
                    offset.z = deltaZFromAbove;
                }
            }
        }
        object.translate(offset);
    }
    getSlot(objIndex, slotIndex) {
        return this.objectsData[objIndex].slots[slotIndex];
    }
    getPoint(objIndex, pointIndex) {
        return this.objectsData[objIndex].inboundSnapPts[pointIndex];
    }
}
exports.GroupBox = GroupBox;
